import type { ComponentProps } from 'react';
import type { LucideIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

/** Shared toolbar action: accessible name, hover/focus help, and a touch target. */
export function IconAction({
  label,
  icon: Icon,
  ...props
}: Omit<ComponentProps<typeof Button>, 'children' | 'size'> & { label: string; icon: LucideIcon }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button {...props} size="icon" title={label} aria-label={label}>
          <Icon aria-hidden="true" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
